import axios from "axios";
import { API } from "../constants";
import { request } from "../constants/request";

export const handleImage = (url, data = {}, method, headers = {}) => {
  const formData = new FormData();
  Object?.keys(data)?.forEach((key) => {
    formData.append(key, data[key]);
  });
  return request({
    url: API.baseUrl + url,
    method: method,
    data: formData,
  });
};
export const fetchImages = (url, method) => {
  return request({
    url: API.baseUrl + url,
    method: method,
  });
};

export const deleteImage = (url, method) => {
  return request({
    url: API.baseUrl + url,
    method: method,
  });
};

export const AddWebsite = (url, payload, method) => {
  return request({
    url: API.baseUrl + url,
    method: method,
    ...(method === "PUT" && { data: payload }),
  });
};
